/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Filename: partnerpackages-resource-factory.js
 *
 * Created by randysorensen on 8/30/17.
 */

'use strict';

angular
.module('prism-ui.components.data')
.factory('PartnerPackagesResourceFactory', function ($resource, EndPointService) {

	return $resource(EndPointService.partnerPackagesEndPoint + '/:partnerPackageId', {
		partnerPackageId: '@partnerPackageId',
	},
	{

		//==================//
		// Partner Packages //
		//==================//

		getPartnerPackage: {
			method: 'GET',
			isArray: false,
		},
		updatePartnerPackage: {
			method: 'PUT',
			isArray: false,
		},


		//============================//
		// Partner Delivery Instances //
		//============================//

		getDeliveryInstances: {
			url: EndPointService.partnerPackagesEndPoint + '/:partnerPackageId/deliveryInstances',
			method: 'GET',
			isArray: true,
			params: {
				partnerPackageId: '@partnerPackageId'
			},
		},
		getDeliveryInstance: {
			url: EndPointService.partnerPackagesEndPoint + '/deliveryInstances/:instanceId',
			method: 'GET',
			params: {
				instanceId: '@instanceId',
			},
			isArray: false,
		},
		updateDeliveryInstance: {
			url: EndPointService.partnerPackagesEndPoint + '/deliveryInstances/:instanceId',
			method: 'PUT',
			params: {
				instanceId: '@instanceId',
			},
			isArray: false,
		},
		createDeliveryInstance: {
			url: EndPointService.partnerPackagesEndPoint + '/:partnerPackageId/deliveryInstances',
			method: 'POST',
			isArray: false,
		},
        getApplicableDeliveryItems: {
            url: EndPointService.partnerPackagesEndPoint + '/:partnerPackageId/applicableDeliveryItems',
            method: 'GET',
            isArray: true
        },
        approvePartnerPackageForPreDeliveryQc: {
            url: EndPointService.partnerPackagesEndPoint + '/:partnerPackageId/approve',
            method: 'PUT',
            params: {
                message: '@message',
            }
        },
        rejectPartnerPackageForPreDeliveryQc: {
            url: EndPointService.partnerPackagesEndPoint + '/:partnerPackageId/reject',
            method: 'PUT',
            params: {
                message: '@message',
            }
        }

	});

});
